import { Breakpoints, styled } from "@vw-marketing/us-components";

import { VWTheme } from "../../../../shared/typings/vw-theme";

interface StyledGenericProps {
  theme: VWTheme;
  hasImage: boolean
}

export const StyledPartialVehicleCardWrapper: any = styled.div`
  ${({ hasImage }: StyledGenericProps) => {
    return `
      align-items: flex-start;
      display: flex;
      flex-direction: column;
      min-width:  ${hasImage ? '232px' : 'auto'};
      min-height: ${hasImage ? '233px' : 'auto'};
      max-height: ${hasImage ? '289px' : 'auto'};

      @media (min-width: ${Breakpoints.b560}px) {
        align-items: flex-start;
        min-width: 366px;
      }

      @media (min-width: ${Breakpoints.b1920}px) {
        min-width: 404px;
      }
    `;
  }}
`;

export const StyledPartialHeaderWrapper: any = styled.div`
  ${({ theme, hasImage }: StyledGenericProps) => {
    return `
      align-items: flex-start;
      align-self: stretch;
      background: ${theme.colors.background.primary};
      border-left: 0.5px solid ${theme.colors.border.default};
      border-radius: ${hasImage ? `12px 12px 0 0` : `12px`};
      border-right: 0.5px solid ${theme.colors.border.default};
      border-top: 0.5px solid ${theme.colors.border.default};
      ${!hasImage && `border-bottom: 0.5px solid ${theme.colors.border.default};`}
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static100};
      padding: ${theme.size.static250} ${theme.size.static350};

      @media (min-width: ${Breakpoints.b560}px) {
        padding: ${theme.size.static300} ${theme.size.static350};
      }
    `;
  }}
`;

export const StyledVehicleInformationContainer: any = styled.div`
  ${({ theme }: StyledGenericProps) => {
    return `
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static100};
      width: 100%;

      div:first-child {
        margin: 0 !important;
      }
    `;
  }}
`;

export const StyledPartialImageWrapper: any = styled.div`
  ${({ theme }: StyledGenericProps) => {
    return `
      align-items: center;
      align-self: stretch;
      display: flex;
      flex-direction: column;
      gap: ${theme.size.static250};
      justify-content: center;
      padding: ${theme.size.static250} ${theme.size.static350};

      background: ${theme.colors.background.tertiary};
      border-bottom: 0.5px solid ${theme.colors.border.default};
      border-left: 0.5px solid ${theme.colors.border.default};
      border-radius: 0 0 12px 12px;
      border-right: 0.5px solid ${theme.colors.border.default};

      @media (min-width: ${Breakpoints.b560}px) {
        padding: ${theme.size.static300} ${theme.size.static350};
        flex-wrap: wrap;
      }
    `;
  }}
`;

export const StyledImageWrapper: any = styled.div`
  align-items: center;
  align-self: stretch;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;
  height: 137px;
  
  img {
    width: 90% !important;
    max-width: 180px !important;
    height: auto !important;
    transform: scale(1.6);
  }

  @media (min-width: ${Breakpoints.b560}px) {
    height: auto;
    justify-content: center;
    
    img {
      width: 100% !important;
      max-width: 125px !important;
      transform: scale(1.5);
    }
  }
`